import React from 'react'
import ReactDOM from 'react-dom'
import OutsideClickHandler from '../containers/OutsideClickHandler'
import {IMaps} from './mapsUtil'
import styles from './StaionCustomMarker.scss'
import MapSpot from '../../assets/icons/MapSpot.svg'
import MapCamp from '../../assets/icons/MapCamp.svg'
import MapActivity from '../../assets/icons/MapActivity.svg'

const Marker = ({ price, selected = true, clickOutside, onClick, isCamp, activityOnly }: {
  price: number
  selected: boolean
  clickOutside: () => void
  onClick?: () => void
  isCamp: boolean
  activityOnly: boolean
}) => <OutsideClickHandler className="w-100 h-100" onClick={onClick} onOutsideClick={clickOutside}>
  <div className={['marker', selected && 'selected'].filter(Boolean).join(' ')}>
    ¥{Intl.NumberFormat('en', { maximumSignificantDigits: 3 }).format(price)}
    {
      isCamp
        ? <MapCamp className="ml-1 mb-1px stationIcon"/>
        : activityOnly
          ? <MapActivity className="ml-1 stationIcon"/>
          : <MapSpot className="ml-1 mb-1px stationIcon"/>
    }
  </div>
</OutsideClickHandler>

export const createMarkerClass = (OverlayView: google.maps.OverlayView) => class CustomMarker extends OverlayView {
    private el: HTMLDivElement | null
    private isDisplay: boolean
    private isSelected: boolean
    private onClickOutbound: void | null

    constructor(
      map: IMaps,
      private price: number,
      private activityOnly: boolean,
      private isCamp: boolean,
      private position: { lat: number, lng: number },
      private onClick?: () => void,
      options: {
        isDisplay: boolean,
        isSelected: boolean
      } = {
        isDisplay: true,
        isSelected: false
      }
    ) {
      super()
      this.position = position
      this.price = price
      this.activityOnly = activityOnly
      this.isCamp = isCamp
      this.onClick = onClick
      this.isDisplay = options.isDisplay
      this.isSelected = options.isSelected

      this.setMap(map)

      this.el = null
      this.onClickOutbound = null
    }

    /**
     * onAdd
     */
    onAdd() {
      this.el = document.createElement('div')

      const className = ((this.isSelected) ? styles.customMarkerSelected : styles.customMarker)
      this.el.classList.add(className)
      this.el.onclick = this.onClick ? () => { this.onClick!() } : null

      if (!this.isDisplay) {
        this.el.style.display = 'none'
      }

      const that = this
      this.onClickOutbound = evt => {
        let targetElement = evt.target // clicked element

        do {
          if (targetElement === that.el) {
            return
          }
          // Go up the DOM
          targetElement = targetElement.parentNode
        } while (targetElement)

        // This is a click outside.
        that.setSelected(false)
      }
      document.addEventListener('click', this.onClickOutbound)

      const panes = this.getPanes()
      panes.overlayLayer.appendChild(this.el)
      ReactDOM.render(
        <Marker
          price={this.price}
          selected={this.isSelected}
          clickOutside={() => { this.setSelected(false) }}
          activityOnly={this.activityOnly}
          isCamp={this.isCamp}
        />,
        this.el
      )

      // click event
      panes.overlayMouseTarget.appendChild(this.el)
      google.maps.event.addDomListener(this.el, 'click', () => {
        google.maps.event.trigger(this, 'click')
        this.setSelected(true)
      })
    }

    /**
     * draw
     */
    draw() {
      if (!this.el) {
        return
      }

      const point = this.getProjection().fromLatLngToDivPixel(
        new google.maps.LatLng(this.position.lat, this.position.lng)
      )
      this.el.style.position = 'absolute'
      this.el.style.left = `${point.x}px`
      this.el.style.top = `${point.y}px`
    }

    /**
     * onRemove
     */
    onRemove() {
      if (!this.el) {
        return
      }
      this.el.parentNode.removeChild(this.el)
      this.el = null
      if (this.onClickOutbound) {
        document.removeEventListener('click', this.onClickOutbound)
        this.onClickOutbound = null
      }
    }

    /**
     * 選択状態のset
     */
    setSelected(boolean) {
      if (boolean === this.isSelected) {
        return
      }

      this.isSelected = boolean
      this.switchClass()
    }

    /**
     * switch class list
     */
    switchClass() {
      if (!this.el) {
        return
      }

      const className = this.isSelected ? styles.customMarkerSelected : styles.customMarker
      this.el.classList.replace(this.el.classList.item(0), className)
    }
}
